// extracted by mini-css-extract-plugin
var _1 = "tf53x";
var _2 = "a8c3b";
var _3 = "I97aT";
var _4 = "PbrLg";
var _5 = "EOKu_";
var _6 = "vDZw_";
export { _1 as "base", _2 as "field", _3 as "theme-dark", _4 as "theme-light", _5 as "variant-fill", _6 as "variant-outline" }
